$(document).ready(function () {
    const wdShop = new library();
    var search_timer;
    var search_isTyping = false;
    var minMediaSwiper = false;
    var maxMediaSwiper = false;
    var minMediaVideoSwiper = false;
    var maxMediaVideoSwiper = false;
    var announcementSwiper = false;
    var commentSwiper = false;
    var recommendationsSwiper = false;
    var reviewSwiper = false;
    wdShop.doCheckTagUrl();
    wdShop.doScrollHeader("#wdshop-footer-scrolltop");
    wdShop.doSiteSidebar();
    if (wdShop.doCheckDomClass('wdshop-vue-app')) {
        setTimeout(function () {
            doVueInit();
        }, 500);
    }
    if (wdShop.doCheckDomClass('wdshop-reviews-sections-list-body')) {
        const dom_height = $('.wdshop-reviews-sections-list-body').height();
        const dom_duration = dom_height / 150;
        // console.log(dom_height);
        $('.wdshop-reviews-sections-list-body').removeAttr('style').attr('style', '--scroll-duration: ' + dom_duration.toFixed(2) + 's;--scroll-distance:' + dom_height + 'px;');
    }
    doResizeCheck();
    // resize
    $(window).resize(function () {
        const isWarp = wdShop.doIsWarp();
        if(!isWarp){
            doResizeCheck();     
        }
    });
    // announcement bar
    function doAnnouncementBar() {
        if (announcementSwiper) {
            announcementSwiper.destroy(true, true);
        }
        const barParams = {
            dom: ".wdshop-announcement-bar-body-list",
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: {
                delay: 8000,
            }
        };
        announcementSwiper = wdShop.doSwiperInit(barParams);
    }
    // home comment
    function doComment() {
        if (commentSwiper) {
            commentSwiper.destroy(true, true);
        }
        let numView = 3;
        const isWarp = wdShop.doIsWarp();
        if (isWarp) {
            numView = 1
        }
        const commentWidth = Math.round($('.wdshop-index-comment-body').width());
        const commentNum = $('.wdshop-index-comment-item').length;
        const commentItemWidth = Math.round(commentWidth / numView);
        let slidesAllWidth = commentItemWidth * (commentNum + 1);
        $('.wdshop-index-comment-list-body')
            .removeAttr('style')
            .attr('style', 'width: ' + slidesAllWidth + 'px;');
        const commentParams = {
            dom: ".wdshop-index-comment-list",
            width: commentWidth,
            autoHeight: true,
            loop: true,
            spaceBetween: 0,
            slidesPerView: numView,
            // mousewheel: false,
            centeredSlides: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: ".wdshop-index-comment-next",
                prevEl: ".wdshop-index-comment-prev",
            },
            pagination: {
                el: ".wdshop-index-comment-pagination",
                clickable: true,
            }
        };
        commentSwiper = wdShop.doSwiperInit(commentParams);
    }
    // home video play
    function doHomeVideoPlay() {
        const bodyDom = $('.wdshop-index-video-body');
        const url = bodyDom.data('url');
        const dom = 'home-video';
        wdShop.doHlsPlay({ dom: dom, url: url });
    }
    // home media video play
    function doHomeMediaVideoPlay() {
        $('.wdshop-index-media-list-body li .wdshop-index-media-item-video-warp .wdshop-index-media-item-video').each(function () {
            const url = $(this).data('url');
            const index = $(this).data('index');
            const dom = 'media-video-' + index;
            wdShop.doHlsPlay({ dom: dom, url: url });
        });
    }
    // header memu
    $('.wdshop-header-menu-item').each(function () {
        $(this).hover(function () {
            $(this).find(".wdshop-header-menu-second-list").show();
        }, function () {
            $(this).find(".wdshop-header-menu-second-list").hide();
        });
    });
    $('.wdshop-header-menu-second-item').each(function () {
        $(this).hover(function () {
            $(this).find(".wdshop-header-menu-last-list").show();
        }, function () {
            $(this).find(".wdshop-header-menu-last-list").hide();
        });
    });
    // search input
    $('.wdshop-header-search-input').each(function () {
        const dom = $(this).parents('.wdshop-header-search-warp').find('.wdshop-header-search-list');
        $(this).on('input', function () {
            search_isTyping = true;
            wdShop.doSearchInputCheck($(this));
            clearTimeout(search_timer);
            search_timer = setTimeout(function () {
                search_isTyping = false;
                wdShop.doSearch(dom);
            }, 1000);
        }).on('blur', function () {
            wdShop.doSearchInputCheck($(this));
            // wdShop.doSearch();
        }).on('keypress', function (e) {
            if (e.which === 13) {
                // wdShop.doSearch();
            }
        }).on('keyup', function (e) {
            if (e.which === 13) {
                wdShop.doSearch();
            } else if (e.target.value.trim().length > 0 && e.which === 8) {
                // wdShop.doSearch();
            }
        });
    });
    // header search icon click
    $('.wdshop-header-icon-search').bind("click", function () {
        $('.wdshop-header-search-bg, .wdshop-header-search-cantact').show();
    });
    $('.wdshop-header-search-close, .wdshop-header-search-bg').bind("click", function () {
        $('.wdshop-header-search-bg, .wdshop-header-search-cantact').hide();
    });
    $('.wdshop-header-search-btn').bind("click", function () {

    });
    $('.wdshop-header-search-btn').each(function () {
        $(this).bind("click", function () {
            const dom = $(this).parents('.wdshop-header-search-warp').find('.wdshop-header-search-list');
            wdShop.doSearch(dom);
        });
    });
    // header search icon click
    $('.wdshop-header-search-result-icon').each(function () {
        $(this).bind("click", function () {
            const url = $(this).data('url');
            window.location.href = url;
        });
    });
    // product sorter
    $('#wdshop-product-header-sorter-select').change(function () {
        const selectedValue = $(this).val();
        const path = $(this).data("path");
        const linker = $(this).data("linker");
        const url = path + '?sort_by=' + selectedValue + linker;
        window.location.href = url;
    });
    // product add to cart
    $('.wdshop-product-add-to-cart').each(function () {
        $(this).bind("click", function () {
            const div = $(this).parent('.wdshop-product-buy-wrap').parent('.wdshop-product-grid-item');
            const itemData = { id: div.data("product-id"), quantity: div.data("product-num") };
            const data = [itemData];
            wdShop.doProductAddToCart(data, { display: true });
        });
    });
    $(".product-desc-body-media .product-desc-body-media-play").each(function () {
        $(this).bind("click", function () {
            var videoId = $(this).parent('.product-desc-body-media').find('#product-desc-body-media-video');
            var imgId = $(this).parent('.product-desc-body-media').find('.product-desc-body-media-video-poster');
            var video = videoId.get(0);
            var icon = $(this);
            imgId.hide();
            videoId.show();
            video.play();
            $(videoId).on('play', function () {
                icon.hide();
            });
            $(videoId).on('ended', function () {
                $(videoId).hide();
                imgId.show();
                icon.show();
            });
        });
    });
    // faq click
    $('.wdshop-page-faq-list li').each(function (index, element) {
        const active = 'wdshop-faq-active';
        const itemDiv = $(this);
        const contentDiv = itemDiv.find('.wdshop-faq-item-content');
        itemDiv.removeAttr('data-index').attr('data-index', index);
        $(this).bind("click", function (event) {
            const otherItemDiv = $(this).siblings();
            const otherContentDiv = otherItemDiv.find('.wdshop-faq-item-content');
            if (otherItemDiv.hasClass(active)) {
                otherItemDiv.removeClass(active);
                otherContentDiv.slideUp();
            }
            if (itemDiv.hasClass(active)) {
                itemDiv.removeClass(active);
                contentDiv.slideUp();
            } else {
                itemDiv.addClass(active);
                contentDiv.slideDown();
            }
        });
    });
    // waiting for execution
    function doWaitingForExecution(callback = false) {
        return new Promise(function (resolve, reject) {
            if (callback) {
                callback();
            }
            resolve();
        });
    }
    // product variant click
    $('.wdshop-product-details-variant-item').each(function () {
        $(this).bind("click", function () {
            const variantId = $(this).data('id');
            const price = $(this).data('price');
            const compare_at_price = $(this).data('compare-at-price');
            const position = $(this).data('position') || false;
            const money_format = $('.wdshop-product-details-variant-body').data('money-format');
            const discountData = wdShop.doCalculateDiscount({ price: price, compare_at_price: compare_at_price, money_format: money_format });
            $('.wdshop-product-details-variant-body').removeAttr('data-id').attr('data-id', variantId);
            if (wdShop.doCheckDomClass('wdshop-product-price')) {
                $('.wdshop-product-price').empty().html(price);
            }
            if (wdShop.doCheckDomClass('wdshop-product-price-compare')) {
                $('.wdshop-product-price-compare').empty().html(compare_at_price);
            }
            if (wdShop.doCheckDomClass('wdshop-product-price-label')) {
                $('.wdshop-product-price-label').empty().html(discountData.discount_text);
            }
            if (wdShop.doCheckDomClass('wdshop-product-price-save')) {
                $('.wdshop-product-price-save').empty().html(discountData.save_text);
            }
            if (wdShop.doCheckDomClass('wdshop-product-details-button-body')) {
                $('.wdshop-product-details-button-body').removeAttr('data-id').attr('data-id', variantId);
            }
            $(this).siblings().removeClass('wdshop-active');
            $(this).addClass('wdshop-active');
            wdShop.doSetUrlParameter('variant', variantId);
            if(minMediaSwiper && position){
                minMediaSwiper.slideTo(position - 1, 300, false);
            }
            if(maxMediaSwiper && position){    
                maxMediaSwiper.slideTo(position - 1, 300, false);
            }
        });
    });
    // product quantity click
    $('.wdshop-product-quantity-minus, .wdshop-product-quantity-plus').each(function () {
        $(this).bind("click", function () {
            const cart = $(this).data('cart') ?? false;
            const type = $(this).data('type');
            const quantityDom = $(this).parent('.wdshop-product-quantity-box');
            const quantityBodyDom = quantityDom.parent('.wdshop-product-quantity-body');
            const dom = quantityDom.find('.wdshop-product-quantity-value .wdshop-product-quantity-number');
            let num = dom.val();
            const min = dom.attr('min');
            switch (type) {
                case 'minus':
                    // minus
                    if (wdShop.doDecimalCompare(num, min, 'gt')) {
                        num = wdShop.doDecimalCalculate(num, 1, 'minus', 0);
                    } else {
                        num = 1;
                    }
                    break;
                default:
                    // plus
                    num = wdShop.doDecimalCalculate(num, 1, 'plus', 0);
                    break;
            }
            dom.val(num);
            if (cart) {
                const totalDom = $(this).parents('.wdshop-cart-items-item').find('.wdshop-cart-td-total') || false;
                const spinnerDom = totalDom.find('.wdshop-cart-td-total-wrap .wdshop-cart-td-total-spinner .wdshop-cart-spinner') || false;
                const totalBodyDom = totalDom.find('.wdshop-cart-td-total-wrap .wdshop-cart-td-total-body') || false;
                const discountDom = totalBodyDom.find('.wdshop-cart-td-details-total') || false;
                const discount = discountDom.data('discount');
                let finalDom = false;
                let originalDom = false;
                if (discount) {
                    finalDom = discountDom.find('.wdshop-cart-td-details-total-span-final') || false;
                    originalDom = discountDom.find('.wdshop-cart-td-details-total-span-original s') || false;
                } else {
                    finalDom = discountDom;
                }
                totalBodyDom.hide();
                spinnerDom.show();
                const id = quantityBodyDom.data('id');
                const key = quantityBodyDom.data('key');
                const money_format = quantityBodyDom.data('money-format');
                const format = wdShop.doGetShopCurrency(money_format);
                let updates = {};
                updates[id] = parseInt(num);
                updateShopifyCart({ updates }, { spinner: spinnerDom, total: totalBodyDom, original: originalDom, final: finalDom, format: format, discount: discount, id: id });
            }
        });
    });
    // Product quantity change
    $('.wdshop-product-quantity-number').each(function () {
        $(this).on("change", function () {
            const cart = $(this).data('cart');
            const num_default = $(this).data('quantity');
            const num = $(this).val();
            if(cart && num > 0 && num !== num_default){
                $(this).data('quantity', num);
                const quantityDom = $(this).parents('.wdshop-product-quantity-box');
                const quantityBodyDom = quantityDom.parent('.wdshop-product-quantity-body');
                const totalDom = $(this).parents('.wdshop-cart-items-item').find('.wdshop-cart-td-total') || false;
                const spinnerDom = totalDom.find('.wdshop-cart-td-total-wrap .wdshop-cart-td-total-spinner .wdshop-cart-spinner') || false;
                const totalBodyDom = totalDom.find('.wdshop-cart-td-total-wrap .wdshop-cart-td-total-body') || false;
                const discountDom = totalBodyDom.find('.wdshop-cart-td-details-total') || false;
                const discount = discountDom.data('discount');
                let finalDom = false;
                let originalDom = false;
                if (discount) {
                    finalDom = discountDom.find('.wdshop-cart-td-details-total-span-final') || false;
                    originalDom = discountDom.find('.wdshop-cart-td-details-total-span-original s') || false;
                } else {
                    finalDom = discountDom;
                }
                totalBodyDom.hide();
                spinnerDom.show();
                const id = quantityBodyDom.data('id');
                const key = quantityBodyDom.data('key');
                const money_format = quantityBodyDom.data('money-format');
                const format = wdShop.doGetShopCurrency(money_format);
                let updates = {};
                updates[id] = parseInt(num);
                updateShopifyCart({ updates }, { spinner: spinnerDom, total: totalBodyDom, original: originalDom, final: finalDom, format: format, discount: discount, id: id });
            }
        });
    });
    // product remove click
    $('.wdshop-product-remove-body').each(function () {
        $(this).bind("click", function () {
            const quantityBodyDom = $(this).parent('.wdshop-product-quantity-body');
            const itemDom = quantityBodyDom.parents('.wdshop-cart-items-item');
            const spinnerDom = itemDom.find('.wdshop-cart-td-total .wdshop-cart-td-total-wrap .wdshop-cart-td-total-spinner .wdshop-cart-spinner') || false;
            const totalBodyDom = itemDom.find('.wdshop-cart-td-total .wdshop-cart-td-total-wrap .wdshop-cart-td-total-body') || false;
            const id = quantityBodyDom.data('id');
            const key = quantityBodyDom.data('key');
            const index = quantityBodyDom.data('index');
            const money_format = quantityBodyDom.data('money-format');
            const format = wdShop.doGetShopCurrency(money_format);
            totalBodyDom.hide();
            spinnerDom.show();
            let updates = {
                line: index,
                quantity: 0,
            };
            removeShopifyCartItem(updates, { dom: itemDom, spinner: spinnerDom, total: totalBodyDom, format: format, id: id });
        });
    });
    // lang click
    $('.wdshop-lang-warp').hover(function () {
        $('.wdshop-lang-list').addClass('wdshop-lang-list-show');
    }, function () {
        $('.wdshop-lang-list').removeClass('wdshop-lang-list-show');
    });
    $('.wdshop-announcement-bar-lang').hover(function () {
        $('.wdshop-lang-header-list').addClass('wdshop-lang-header-list-show');
    }, function () {
        $('.wdshop-lang-header-list').removeClass('wdshop-lang-header-list-show');
    });
    $('.wdshop-lang-list .wdshop-lang-item a, .wdshop-lang-header-list .wdshop-lang-header-item a').each(function () {
        $(this).bind("click", function () {
            const country = $(this).find('.wdshop-lang-country').html();
            const currency = $(this).find('.wdshop-lang-currency').html();
            const countrySelect = $(this).data('value');
            Shopify.country = countrySelect;
            $('.wdshop-lang-available').empty().html(country + ' | ' + currency);
            $('input[name="country_code"]').val(countrySelect);
            localStorage.setItem('lvy_user_local', countrySelect);
            localStorage.setItem('lvy_user_local_set', true);
            $('#localization_form').submit();
        });
    });
    // update Shopify Cart
    async function removeShopifyCartItem(formData, paramsData = false, refresh = true) {
        const format = paramsData.format || '$';
        const id = paramsData.id || false;
        const dom = paramsData.dom || false;
        const original = paramsData.original || false;
        const final = paramsData.final || false;
        const change = await wdShop.doShopifyCartChange(formData);
        const totalDom = $('.wdshop-cart-footer-estimated-total');
        const currency = totalDom.data('currency') || 'USD';
        if (change.code == 0) {
            if (!refresh) {
                const cartData = await wdShop.doGetShopifyCartData();
                if (cartData.code == 0) {
                    const count = cartData.data?.item_count || 0;
                    const total_discount = format + wdShop.doDecimalCalculate(cartData.data?.total_discount, 100, 'div');
                    const original_total_price = format + wdShop.doDecimalCalculate(cartData.data?.original_total_price, 100, 'div');
                    const total_price = format + wdShop.doDecimalCalculate(cartData.data?.total_price, 100, 'div');
                    const total_weight = cartData.data?.total_weight;
                    totalDom.empty().html(total_price + ' ' + currency);
                    wdShop.doRenewShopifyCartCount(count);
                    if (dom) {
                        dom.remove();
                    }
                }
                spinner.hide();
                total.show();
            } else {
                location.reload();
            }
        }
    }
    // update Shopify Cart
    async function updateShopifyCart(formData, paramsData = false) {
        const spinner = paramsData.spinner || false;
        const total = paramsData.total || false;
        const original = paramsData.original || false;
        const final = paramsData.final || false;
        const format = paramsData.format || '$';
        const discount = paramsData.discount ?? false;
        const id = paramsData.id || false;
        const update = await wdShop.doShopifyCartUpdate(formData);
        const totalDom = $('.wdshop-cart-footer-estimated-total');
        const currency = totalDom.data('currency') || 'USD';
        if (update.code == 0) {
            const cartData = await wdShop.doGetShopifyCartData();
            if (cartData.code == 0) {
                const items = cartData.data?.items || [];
                const count = cartData.data?.item_count || 0;
                const total_discount = format + wdShop.doDecimalCalculate(cartData.data?.total_discount, 100, 'div');
                const original_total_price = format + wdShop.doDecimalCalculate(cartData.data?.original_total_price, 100, 'div');
                const total_price = format + wdShop.doDecimalCalculate(cartData.data?.total_price, 100, 'div');
                const total_weight = cartData.data?.total_weight;
                items.forEach(function (item, index) {
                    if (item.variant_id == id) {
                        const final_line_price = format + wdShop.doDecimalCalculate(item.final_line_price, 100, 'div');
                        const original_line_price = format + wdShop.doDecimalCalculate(item.original_line_price, 100, 'div');
                        if (discount) {
                            original.empty().html(original_line_price);
                        }
                        final.empty().html(final_line_price);
                    }
                });
                totalDom.empty().html(total_price + ' ' + currency);
                wdShop.doRenewShopifyCartCount(count);
            }
            spinner.hide();
            total.show();
        }
    }
    // product add to cart
    $('.wdshop-product-details-button-cart').each(function () {
        $(this).bind("click", function () {
            const data = wdShop.doGetProductDetailsBuyData($(this));
            if (!data) {
                return false;
            }
            wdShop.doProductAddToCart(data, { display: true });
        });
    });
    // product buy
    $('.wdshop-product-details-button-buy').each(function () {
        $(this).bind("click", function () {
            const data = wdShop.doGetProductDetailsBuyData($(this));
            if (!data) {
                return false;
            }
            wdShop.doProductAddToCart(data, { display: false, checkout: true });
        });
    });
    // cart close
    $('.wdshop-cart-header-action-continue, .wdshop-cart-close').each(function () {
        const showName = 'wdshop-cart-show';
        const bgName = 'wdshop-cart-cart-bg';
        const cartName = 'wdshop-cart-wrap';
        $(this).bind("click", function () {
            if (wdShop.doCheckDomClass(bgName)) {
                const bgDom = $('.' + bgName);
                if (bgDom.hasClass(showName)) {
                    bgDom.removeClass(showName);
                }
            }
            if (wdShop.doCheckDomClass(cartName)) {
                const cartDom = $('.' + cartName);
                if (cartDom.hasClass(showName)) {
                    cartDom.removeClass(showName);
                }
            }
        });
    });
    // cart checkout
    $('.wdshop-cart-checkout').each(function () {
        $(this).bind("click", function () {
            wdShop.doCheckout();
        });
    });
    // product media
    function doProductMedia() {
        if (minMediaSwiper) {
            minMediaSwiper.destroy(true, true);
        }
        if (maxMediaSwiper) {
            maxMediaSwiper.destroy(true, true);
        }
        if (minMediaVideoSwiper) {
            minMediaVideoSwiper.destroy(true, true);
        }
        if (maxMediaVideoSwiper) {
            maxMediaVideoSwiper.destroy(true, true);
        }
        // header
        if (wdShop.doCheckDomClass('wdshop-product-details-media-header-list')) {
            const header_hover = 'wdshop-product-details-media-header-hover';
            const body_hover = 'wdshop-product-details-media-body-no-hover';
            $('.wdshop-product-details-media-header-list .wdshop-product-details-media-header-item').each(function () {
                $(this).bind("click", function () {
                    $(this).siblings().removeClass(header_hover);
                    $(this).addClass(header_hover);
                    const header_type = $(this).data('type');
                    switch (header_type) {
                        case 'video':
                            $('#wdshop-product-details-media-images').addClass(body_hover);
                            $('#wdshop-product-details-media-video').removeClass(body_hover);
                            break;
                        default:
                            $('#wdshop-product-details-media-images').removeClass(body_hover);
                            $('#wdshop-product-details-media-video').addClass(body_hover);
                            break;
                    }
                });
            });
        }
        const mediaWidth = $('.wdshop-product-body-left').width();
        // $('.wdshop-product-body-fixed').removeAttr('style').attr('style', 'width: ' + mediaWidth + 'px; opacity:1;');
        const thumbnailDom = $('.wdshop-product-details-media-images-thumbnail');
        const thumbnailVideoDom = $('.wdshop-product-details-media-video-thumbnail');
        const maxMediaWidth = $('.wdshop-product-details-media-preview').width();
        const minMediaWidth = $('.wdshop-product-details-media-prev').width();
        const sideNumDiv = Math.round(maxMediaWidth) / (Math.round(minMediaWidth) + 10);
        const sideNum = parseFloat(sideNumDiv.toFixed(2));
        const minMediaHeight = maxMediaWidth + 2;
        if (thumbnailDom.css('display') !== 'none') {
            thumbnailDom.removeAttr('style').attr('style', 'height: ' + parseFloat(minMediaHeight.toFixed(2)) + 'px;');
            // 缩略图
            const minParams = {
                dom: ".wdshop-product-details-media-images-thumbnail-list-warp",
                direction: 'vertical',
                loop: false,
                spaceBetween: 10,
                slidesPerView: Math.floor(sideNum),
                mousewheel: false,
                freeMode: true,
                watchSlidesProgress: true,
            };
            minMediaSwiper = wdShop.doSwiperInit(minParams);
        }
        // 大图
        const maxParams = {
            dom: ".wdshop-product-details-media-images-preview",
            width: parseFloat(maxMediaWidth.toFixed(2)),
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1,
            mousewheel: false,
            navigation: {
                nextEl: ".wdshop-product-details-media-images-next",
                prevEl: ".wdshop-product-details-media-images-prev",
            },
            pagination: {
                el: ".wdshop-product-details-media-images-pagination",
                clickable: true,
            },
            thumbs: {
                swiper: minMediaSwiper,
            },
        };
        maxMediaSwiper = wdShop.doSwiperInit(maxParams);
        $('.wdshop-product-details-media-images-preview-list').removeAttr('style').attr('style', 'opacity:1;');

        if (wdShop.doCheckDomClass('wdshop-product-details-media-video-body')) {
            if (thumbnailVideoDom.css('display') !== 'none') {
                thumbnailVideoDom.removeAttr('style').attr('style', 'height: ' + parseFloat(minMediaHeight.toFixed(2)) + 'px;');
                // 缩略图
                const minVideoParams = {
                    dom: ".wdshop-product-details-media-video-thumbnail-list-warp",
                    direction: 'vertical',
                    loop: false,
                    spaceBetween: 10,
                    slidesPerView: Math.floor(sideNum),
                    mousewheel: false,
                    freeMode: true,
                    watchSlidesProgress: true,
                };
                minMediaVideoSwiper = wdShop.doSwiperInit(minVideoParams);
            }
            // 大图
            const maxVideoParams = {
                dom: ".wdshop-product-details-media-video-preview",
                width: maxMediaWidth,
                loop: false,
                spaceBetween: 0,
                slidesPerView: 1,
                mousewheel: false,
                navigation: {
                    nextEl: ".wdshop-product-details-media-video-next",
                    prevEl: ".wdshop-product-details-media-video-prev",
                },
                pagination: {
                    el: ".wdshop-product-details-media-video-pagination",
                    clickable: true,
                },
                thumbs: {
                    swiper: minMediaVideoSwiper,
                },
            };
            maxMediaVideoSwiper = wdShop.doSwiperInit(maxVideoParams);
            $('.wdshop-product-details-media-video-preview-list').removeAttr('style').attr('style', 'opacity:1;');
        }
        if (wdShop.doCheckDomClass('wdshop-product-details-media-preview-item-video-icon')) {
            wdShop.doVideoPlay();
        }
    }
    // product recommendations
    async function doProductRecommendations() {
        if (recommendationsSwiper) {
            recommendationsSwiper.destroy(true, true);
        }
        const res = await wdShop.doShopifyRecommendations();
        const isWarp = wdShop.doIsWarp();
        const pageSize = wdShop.doGetPageSize();
        let sizeNum = 0.2;
        if(!isWarp && pageSize.width > 1200 && pageSize.width <= 1600 ){
            sizeNum = 0.25;
        }
        if(!isWarp && pageSize.width >= 768 && pageSize.width <= 1200 ){
            sizeNum = 0.3333;
        }
        if (res.code == 0) {
            const recommendationsWidth = Math.round($('.wdshop-product-like-list-warp').width());
            const recommendationsItemWidth = Math.round(recommendationsWidth * sizeNum);
            const sideNum = Math.round(recommendationsWidth / recommendationsItemWidth);
            let slidesCount = Math.floor(sideNum);
            let slidesAllWidth = recommendationsItemWidth * (res.data.limit + 1);
            if (isWarp) {
                slidesCount = 1;
                slidesAllWidth = recommendationsWidth * res.data.limit;
            }
            $('.wdshop-product-like-list-body')
                .removeAttr('style')
                .attr('style', 'width: ' + slidesAllWidth + 'px;');
            const recommendations_params = {
                dom: '.wdshop-product-like-list-warp',
                width: recommendationsWidth,
                loop: false,
                spaceBetween: 0,
                slidesPerView: slidesCount,
                mousewheel: false,
                navigation: {
                    nextEl: '.wdshop-product-like-next',
                    prevEl: '.wdshop-product-like-prev',
                },
            };
            recommendationsSwiper = wdShop.doSwiperInit(recommendations_params);
        }
    }
    // product media fixed
    function doProductMediaFixed() {
        //if (!wdShop.doIsWarp()) {
            let mediaRightHeight = $('.wdshop-product-body-right').height();
            let mediaOffsetTop = $('.wdshop-product-body-right').offset().top;
            let mediaHeight = $('.wdshop-product-body-fixed').height();
            let diffHeight = wdShop.doDecimalCalculate(mediaRightHeight, mediaHeight, 'minus', 2);
            diffHeight = wdShop.doDecimalCalculate(diffHeight, 15, 'minus', 2);
            let minHeight = wdShop.doDecimalCalculate(diffHeight, mediaOffsetTop, 'plus', 2);
            let style = false;
            if ($('.wdshop-product-body-fixed').attr('style') !== undefined) {
                style = $('.wdshop-product-body-fixed').attr('style');
            }
            $(window).scroll(function () {
                let scrollTop = $(window).scrollTop();
                let top = wdShop.doDecimalCalculate(scrollTop, mediaOffsetTop, 'minus', 0);
                if (wdShop.doDecimalCompare(scrollTop, mediaOffsetTop, 'gt') && wdShop.doDecimalCompare(scrollTop, minHeight, 'lt')) {
                    // scroll star
                    $('.wdshop-product-body-fixed').addClass('wdshop-absolute');
                    if (style) {
                        $('.wdshop-product-body-fixed').css({
                            top: top + 'px'
                        });
                    }
                } else if (wdShop.doDecimalCompare(scrollTop, minHeight, 'gt')) {
                    $('.wdshop-product-body-fixed').css({
                        top: diffHeight + 'px'
                    });
                } else if (wdShop.doDecimalCompare(scrollTop, mediaOffsetTop, 'eq')) {
                    $('.wdshop-product-body-fixed').removeClass('wdshop-absolute');
                    $('.wdshop-product-body-fixed').css({
                        top: '0px'
                    });
                }
            });
        //}
    }
    // Submit Form
    function doSubmitForm() {
        $('.wdshop-submit').each(function () {
            $(this).click(function (event) {
                event.preventDefault();
                wdShop.doSubmitFormData($(this), event);
            });
        });
        $('#wdshop-form').each(function () {
            $(this).keypress(function (event) {
                if (event.which == 13) {
                    event.preventDefault();
                    wdShop.doSubmitFormData($(this), event);
                }
            });
        });
    }
    // Vue Init
    function doVueInit() {
        const vueApp = {
            data() {
                return {
                    price_range: [0, 0],
                    price_min: 0,
                    price_max: 0,
                    price_min_default: 0,
                    price_max_default: 0,
                    request_path: false,
                    range_show:'display: none;',
                }
            },
            computed: {
            },
            created() {
                const that = this;
                that.doGetData();
            },
            methods: {
                doGetData() {
                    const that = this;
                    const dom = $('#wdshop-sidebar-vue-app');
                    const request_path = dom.data('path') || false;
                    const min = dom.data('min') || 0;
                    const max = dom.data('max') || 0;
                    const price_min = Math.floor(min / 100);
                    const price_max = Math.round(max / 100);
                    let price_min_default = price_min;
                    let price_max_default = price_max;
                    let filter_data = localStorage.getItem('wdShop_filter_price') || false;
                    if (filter_data) {
                        filter_data = JSON.parse(filter_data);
                        if (filter_data.path == request_path) {
                            price_min_default = filter_data.min;
                            price_max_default = filter_data.max;
                        }
                    }
                    that.$data.price_min = price_min;
                    that.$data.price_max = price_max;
                    that.$data.price_min_default = price_min_default;
                    that.$data.price_max_default = price_max_default;
                    that.$data.price_range[0] = price_min;
                    that.$data.price_range[1] = price_max;
                    that.$data.request_path = request_path;
                    that.$data.range_show = 'display: block;';
                },
                doChangeMin(e) {
                    const that = this;
                    let num = parseInt(e);
                    if (num < that.$data.price_min_default) {
                        num = that.$data.price_min_default;
                    }
                    that.$data.price_min = num;
                    that.$data.price_range[0] = num;
                },
                doChangeMax(e) {
                    const that = this;
                    let num = parseInt(e);
                    if (num > that.$data.price_max_default) {
                        num = that.$data.price_max_default;
                    }
                    that.$data.price_max = num;
                    that.$data.price_range[1] = num;
                },
                doChangeSlider(e) {
                    const that = this;
                    that.$data.price_min = e[0];
                    that.$data.price_max = e[1];
                    that.$data.price_range = e;
                    that.doConfirm();
                },
                doApply() {
                    const that = this;
                    that.doConfirm();
                },
                doConfirm() {
                    const that = this;
                    const request_path = that.$data.request_path;
                    if (request_path) {
                        localStorage.setItem('wdShop_filter_price', JSON.stringify({ min: that.$data.price_min_default, max: that.$data.price_max_default, path: request_path }));
                        window.location.href = request_path + '?filter.v.price.gte=' + that.$data.price_min + '&filter.v.price.lte=' + that.$data.price_max;
                    }
                }
            }
        }
        const vue = Vue.createApp(vueApp);
        vue.use(ElementPlus);
        vue.mount("#wdshop-sidebar-vue-app");
    }
    // resize check
    function doResizeCheck() {
        doClickPageNavigation();
        doSetFooterWarp();
        if (wdShop.doCheckDomClass('wdshop-announcement-bar-body')) {
            doAnnouncementBar();
        }
        if (wdShop.doCheckDomClass('wdshop-index-video-body')) {
            doHomeVideoPlay();
        }
        if (wdShop.doCheckDomClass('wdshop-index-media-list-body')) {
            doHomeMediaVideoPlay();
        }
        if (wdShop.doCheckDomClass('wdshop-index-comment-list')) {
            doComment();
        }
        if (wdShop.doCheckDomClass('wdshop-product-details-media-body')) {
            doProductMedia();
        }
        if (wdShop.doCheckDomClass('wdshop-product-body-fixed')) {
            doProductMediaFixed();
        }
        if (wdShop.doCheckDomClass('wdshop-product-like-wrap')) {
            doProductRecommendations();
        }
        if (wdShop.doCheckDomClass('wdshop-submit')) {
            doSubmitForm();
        }
        if (wdShop.doCheckDomClass('wdshop-header-search-input')) {
            wdShop.doSearchInputCheck($('.wdshop-header-search-input'));
            if ($('.wdshop-header-search-input').val() !== '') {
                wdShop.doSearch();
            }
        }
        doSidebar();
    }
    // sidebar
    function doSidebar() {
        const isWarp = wdShop.doIsWarp();
        $('.wdshop-sidebar-title-mobile').each(function () {
            const handle = $(this).data("handle") || false;
            const showClass = 'wdshop-sidebar-show';
            const activeClass = 'wdshop-sidebar-active';
            const itemParentActiveClass = 'wdshop-sidebar-item-active';
            let sidebarDiv = false;
            let itemParentDiv = $(this).parent('.wdshop-sidebar-title');
            if (handle) {
                sidebarDiv = $('#wdshop-sidebar-' + handle);
            }
            if (isWarp && sidebarDiv) {
                sidebarDiv.slideUp();
                if (sidebarDiv.hasClass(showClass)) {
                    sidebarDiv.slideDown();
                }
            }
            if (!isWarp && sidebarDiv) {
                sidebarDiv.slideDown();
            }
            if (isWarp && sidebarDiv) {
                $(this).bind("click", function () {
                    doClickSidebar({
                        click: $(this),
                        parent: itemParentDiv,
                        parentActive: itemParentActiveClass,
                        active: activeClass,
                        item: sidebarDiv,
                    });
                });
            }else{
                $(this).unbind();
            }
        });
    }
    // click sidebar
    function doClickSidebar(paramsData = false) {
        const active = paramsData.active ?? false;
        const item = paramsData.item ?? false;
        const parent = paramsData.parent ?? false;
        const parentActive = paramsData.parentActive ?? false;
        if (active && item) {
            if (item.hasClass(active)) {
                item.removeClass(active);
                item.slideUp();
                if(parent && parentActive){
                    parent.removeClass(parentActive);
                }
            } else {
                item.addClass(active);
                item.slideDown();
                if(parent && parentActive){
                    parent.addClass(parentActive);
                }
            }
        }
    }
    // page navigation click
    function doClickPageNavigation() {
        const clickDiv = $('.wdshop-page-sidebar-text');
        const sidebarClass = "wdshop-page-sidebar-show";
        const sidebarDiv = $(".wdshop-page-sidebar-container");
        const isWarp = wdShop.doIsWarp();
        if (isWarp) {
            clickDiv.bind("click", function () {
                if (sidebarDiv.hasClass(sidebarClass)) {
                    sidebarDiv.slideDown().removeClass(sidebarClass);
                } else {
                    sidebarDiv.slideUp().addClass(sidebarClass);
                }
            });
        } else {
            clickDiv.unbind();
            sidebarDiv.slideDown();
            if (sidebarDiv.hasClass(sidebarClass)) {
                sidebarDiv.addClass(sidebarClass);
            }
        }
    }
    // set footer
    function doSetFooterWarp() {
        const paramsData = {
            active: 'wdshop-active',
            item: 'wdshop-footer-tit-warp',
            show: 'wdshop-footer-showItem',
            parent: 'wdshop-footer-wp'
        }
        wdShop.doClickToExpand(paramsData);
    }
});